import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=236f078b"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports